var __MUNEME_V=3;
// Fallback: libs.min.js が jQuery 未ロード時に crash した場合、
// Image--lazyLoad 画像を強制表示する（コレクション/ブログページ対応）
(function(){
  if (window.location.pathname === '/') return;
  var timer = setTimeout(function(){
    var items = document.querySelectorAll('.Image--lazyLoad');
    if (!items.length) return;
    items.forEach(function(img){
      var src = img.dataset.src;
      if (src && !img.src) {
        var w = img.closest('.AspectRatio');
        var width = (w && w.offsetWidth) || 600;
        img.src = src.replace('{width}', width);
        img.classList.remove('Image--lazyLoad');
        img.classList.add('Image--loaded');
      }
    });
    document.querySelectorAll('.ProductItem, .ArticleItem').forEach(function(el){
      if (getComputedStyle(el).visibility === 'hidden') el.style.visibility = 'visible';
    });
  }, 3000);
  // theme.js が正常に動作した場合はフォールバック不要
  var observer = new MutationObserver(function(mutations){
    var loaded = document.querySelector('.Image--loaded, .Image--lazyLoaded');
    if (loaded) { clearTimeout(timer); observer.disconnect(); }
  });
  observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'] });
})();
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(function ($) {
  // PageSpeed: the loading overlay now self-dismisses in CSS, so custom.js no longer gates first paint on jQuery.
  if (window.Swiper && document.querySelector('.slideshow-swiper')) {
    new Swiper('.slideshow-swiper', {
              loop: true,
              grabCursor: false,
              simulateTouch: false,
              slidesPerView: 1,
              autoplay:true,
              speed: 2000,
              effect: 'fade',
              autoplay: {
                delay: 3000,
                disableOnInteraction: false
              },
              fadeEffect: {
                  crossFade: true
              },
              pagination: {
                  el: '.slideshow-swiper .swiper-pagination',
                  clickable: true
              }
      });
  }

  if (window.Swiper && document.querySelector('.column-swiper')) {
    new Swiper('.column-swiper', {
            direction: 'horizontal',
            loop: false,
            pagination: {
                el: '.column-swiper .swiper-pagination',
            },
            navigation: {
                nextEl: '.column-swiper .swiper-button-next',
                prevEl: '.column-swiper .swiper-button-prev',
            },
            scrollbar: {
                el: '.column-swiper .swiper-scrollbar',
            },
            grabCursor: true,
            slidesPerView: 'auto',
            spaceBetween: 30,
            mousewheel: false,
            breakpoints: {
                640: {
                    slidesPerView: 'auto',
                    spaceBetween: 50
                }
            }
        });
  }
})

jQuery(function ($) {
  $('.c-faq__item .q').on('click', function(){
    $(this).toggleClass('is-active');
    $(this).next().slideToggle();
  })

})

jQuery(function($){
  let count = true;
  let tl;

  function waitForUseCarouselImages(callback){
    const $carousel = $('.use-carousel');
    const images = $carousel.find('img').get();
    const pendingImages = images.filter(function(img){
      if(img.loading === 'lazy'){
        img.loading = 'eager';
      }
      return !img.complete;
    });

    if(!pendingImages.length){
      callback();
      return;
    }

    let remaining = pendingImages.length;
    function completeImage(){
      remaining -= 1;
      if(remaining === 0){
        callback();
      }
    }
    pendingImages.forEach(function(img){
      if(img.complete){
        completeImage();
        return;
      }
      $(img).one('load error', function(){
        completeImage();
      });
    });
  }

  function setup(){
    if(window.location.pathname == '/') {
    gsap.killTweensOf('.use-carousel .slide-item');
    if(tl){
      tl.kill();
    }
    //Setup Variables
    let firstSlide = $('.use-carousel .slide-item').eq(0).get(0);
    if(!firstSlide){
      return;
    }
    let slide = firstSlide.getBoundingClientRect();
    let slideHeight = slide.height;
    let slideWidth = slide.width;
    if(!slideHeight || !slideWidth){
      return;
    }
    if($(window).width() < 961 && count){
      $('.use-carousel .slide-item').clone(true).appendTo('.use-carousel');
      count=false;
    }
    let slideItems = $('.use-carousel .slide-item').length;

    // Gsap Time //
    let totalHeight= slideItems*slideHeight;
    let totalWidth= slideItems*slideWidth;

    let wrap_pc = gsap.utils.wrap(-slideHeight,totalHeight-slideHeight);
    let wrap_sp = gsap.utils.wrap(-slideWidth,totalWidth-slideWidth);
    let yheight = "-=" + totalHeight;
    let xwidth = "-=" + totalWidth;

    if($(window).width() < 961){
        gsap.set(".use-carousel .slide-item", {
          x: (i) => i * slideWidth,
          y: 0
        });
    }else{
        gsap.set(".use-carousel .slide-item", {
          x: 0,
          y: (i) => i * slideHeight
        });
    }

    tl = gsap.timeline();
    let tlOptions = {
        duration: 40,
        ease: "none",
        repeat: -1
    }

    let pc_tlOptions = {
      ...tlOptions,
      y: yheight,
        modifiers: {
          y: gsap.utils.unitize(wrap_pc)
      }
    }
    let sp_tlOptions = {
        ...tlOptions,
        x: xwidth,
          modifiers: {
            x: gsap.utils.unitize(wrap_sp)
        }
    }

    if($(window).width() < 961){
      tl.to(".use-carousel .slide-item", sp_tlOptions);
    }else{
      tl.to(".use-carousel .slide-item", pc_tlOptions);
    }

    ScrollTrigger.create({
        trigger: ".l-about",
        start: "top top",
        endTrigger: "#shopify-section-template--16587442651368__165761386360af2261",
        end: "bottom bottom",
        scroller: "html",
        markers: false,
    });
    }
  }

  window.__initGsapCarousel = function(){
    if (!window.gsap || !window.ScrollTrigger) {
      return;
    }

    setTimeout(function(){
      waitForUseCarouselImages(setup);
    }, 1000)
  };

  if (window.gsap && window.ScrollTrigger) {
    window.__initGsapCarousel();
  }

  let ww = $(window).width();
  $(window).on('resize',  function(){
    if (!window.gsap || !window.ScrollTrigger) {
      return;
    }

    if($(window).width() == ww){
       ww = $(window).width();
      return;
    }else{
      waitForUseCarouselImages(setup);
      ww = $(window).width();
    }
  });
})

jQuery(function(){
  window.__initGsapFadein = function(){
    if (!window.gsap || !window.ScrollTrigger || window.__gsapFadeinInitialized) {
      return;
    }

    window.__gsapFadeinInitialized = true;

    gsap.fromTo(".l-line__block .image img",
      { y: 35, },
      {
          y: 0,
          scrollTrigger: {
              trigger: "#shopify-section-template--16587442651368__16575344712355576d",
              start: "bottom center",
              endTrigger: "#shopify-section-template--16587442651368__165753455788e7b39c",
              end: "bottom bottom",
              scroller: "html",
              markers: false,
              toggleActions: 'play none none reverse',
          }
      }
  );

    gsap.utils.toArray('.fadein').forEach(function(fadeItem) {
      var rect = fadeItem.getBoundingClientRect();
      // If already in or above viewport when GSAP loads late, animate immediately
      if (rect.top < window.innerHeight) {
        gsap.fromTo(fadeItem, { autoAlpha: 0, y: 70 }, {
          duration: 1.2, autoAlpha: 1, y: 0
        });
      } else {
        gsap.fromTo(fadeItem, { autoAlpha: 0, y: 70 }, {
          scrollTrigger: { trigger: fadeItem, once: true, markers: false },
          duration: 1.2, autoAlpha: 1, y: 0
        });
      }
    });
  };

  if (window.gsap && window.ScrollTrigger) {
    window.__initGsapFadein();
  }
})

jQuery(function($){
  $('.modal-open').click(function(event) {
    var target = $('#' + $(this).data('modal'));
    if (typeof $.fn.modal === 'function') {
      target.modal({ fadeDuration: 250 });
    } else {
      // Fallback: jquery-modal未ロード時の簡易モーダル表示
      target.css({ display: 'block', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999, background: 'rgba(0,0,0,0.8)' });
      target.on('click', function(e) { if (e.target === this) target.css('display', 'none'); });
    }
    return false;
  });

  if (document.getElementById('shopify-product-reviews')) {
    var wait = setInterval(function () {
        if (typeof SPR != 'undefined') {
              SPR.toggleForm = function(e){
                this.$("#shopify-product-reviews[data-id='" + e + "']").find('.spr-header').toggle();
                return this.$("#shopify-product-reviews[data-id='" + e + "']")
                    .find(".spr-form")
                    .toggle();
              }
            $('.spr-summary-actions-newreview').trigger('click');
            clearInterval(wait);
        }
    }, 250);
  }
})

jQuery(function($){
  var previousScroll = 0,
      header = $('#shopify-section-header');

  $(window).on("scroll", function(){
     var currentScroll = $(this).scrollTop();

     if(currentScroll > 0){
       header.addClass('is-scrolled');
       if (currentScroll > previousScroll){
          header.addClass('is-hidden');
       } else {
          header.removeClass('is-hidden');
       }
      }else{
         header.removeClass('is-scrolled');
      }
      previousScroll = currentScroll;
  });

});

// simpleParallax: デスクトップのみ、window.load + idle後に動的ロード（PSIモバイルのTBT影響を除去）
function __muneme_initSP(w, d) {
  function initSimpleParallax() {
    new simpleParallax(d.querySelectorAll('.parallax-img-dl-1'), { delay: .1 });
    new simpleParallax(d.querySelectorAll('.parallax-img-dl-2'), { delay: .2 });
    new simpleParallax(d.querySelectorAll('.parallax-img-dl-3'), { delay: .3 });
    new simpleParallax(d.querySelectorAll('.parallax-img-dl-4'), { delay: .4 });
    new simpleParallax(d.querySelectorAll('.parallax-img-dl-5'), { delay: .5 });
    new simpleParallax(d.querySelectorAll('.parallax-img-dl-6'), { delay: .6 });
    new simpleParallax(d.querySelectorAll('.parallax-img'), { delay: .3, scale: 1.15 });
    new simpleParallax(d.querySelectorAll('.parallax-img-of'), { delay: .3, overflow: true });
  }

  function shouldLoadParallax() {
    if (w.innerWidth < 768) return false;
    return !!(d.querySelector('.parallax-img') || d.querySelector('.parallax-img-dl-1'));
  }

  function loadAndInitParallax() {
    if (!shouldLoadParallax()) return;
    var s = d.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/simple-parallax-js@5.5.1/dist/simpleParallax.min.js';
    s.onload = initSimpleParallax;
    d.head.appendChild(s);
  }

  function scheduleParallax() {
    (w.requestIdleCallback || function(cb) { w.setTimeout(cb, 1500); })(loadAndInitParallax);
  }

  if (d.readyState === 'complete') {
    scheduleParallax();
  } else {
    w.addEventListener('load', scheduleParallax, { once: true });
  }
}
__muneme_initSP(window, document);

function __muneme_initGsap(w, d) {
  var gsapLoaded = false;
  var gsapLoading = false;

  function loadScript(src, integrity, callback) {
    var script = d.createElement('script');
    script.src = src;
    script.integrity = integrity;
    script.crossOrigin = 'anonymous';
    script.referrerPolicy = 'no-referrer';
    script.onload = callback;
    d.head.appendChild(script);
  }

  function runGsapInitializers() {
    if (!w.gsap || !w.ScrollTrigger) {
      return;
    }

    if (typeof w.gsap.registerPlugin === 'function') {
      w.gsap.registerPlugin(w.ScrollTrigger);
    }

    if (typeof w.__initGsapCarousel === 'function') {
      w.__initGsapCarousel();
    }

    if (typeof w.__initGsapFadein === 'function') {
      w.__initGsapFadein();
    }
  }

  function loadGsap() {
    if (gsapLoaded || gsapLoading) {
      return;
    }

    gsapLoading = true;
    loadScript(
      'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.10.4/gsap.min.js',
      'sha512-VEBjfxWUOyzl0bAwh4gdLEaQyDYPvLrZql3pw1ifgb6fhEvZl9iDDehwHZ+dsMzA0Jfww8Xt7COSZuJ/slxc4Q==',
      function(){
        loadScript(
          'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.10.4/ScrollTrigger.min.js',
          'sha512-v8B8T8l8JiiJRGomPd2k+bPS98RWBLGChFMJbK1hmHiDHYq0EjdQl20LyWeIs+MGRLTWBycJGEGAjKkEtd7w5Q==',
          function(){
            gsapLoaded = true;
            gsapLoading = false;
            runGsapInitializers();
          }
        );
      }
    );
  }

  function shouldLoadGsap() {
    return !!(
      d.querySelector('.use-carousel') ||
      d.querySelector('.fadein') ||
      d.querySelector('.l-line__block .image img')
    );
  }

  function scheduleGsapLoad() {
    if (!shouldLoadGsap()) {
      return;
    }
    (w.requestIdleCallback || function(callback) {
      w.setTimeout(callback, 1500);
    })(loadGsap);
  }

  if (d.readyState === 'complete') {
    scheduleGsapLoad();
  } else {
    w.addEventListener('load', scheduleGsapLoad, { once: true });
  }
}
__muneme_initGsap(window, document);
